import AnimMediaControl from './anim-media-control';
import type { IMediaParams } from '@src/slide/application/service/media-manager/params.interface';
import { MediaRegion, type IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';

export default class PlayerAnimAudioControl extends AnimMediaControl {
    public static instance: PlayerAnimAudioControl;
    public static getInstance(mediaManager: IMediaManager): PlayerAnimAudioControl {
        if (!this.instance) {
            this.instance = new PlayerAnimAudioControl(mediaManager);
        }
        return this.instance;
    }


    public isPlaying(): boolean {
        const audio = this.mediaManager.getAudioInstanceByRegion(this.elementModel?.key, MediaRegion.PLAYER);
        if (!audio) {
            return false;
        }
        return !audio.paused;
    }

    public completeMediaControl(mediaParams: IMediaParams): void | undefined {
        this.mediaManager.resetAudioByRegion(mediaParams.elementModel.key, MediaRegion.PLAYER);
    }

    // media开始播放
    protected playHandler(): void {
        if (this.animStopAtLength && this.animStopAtLength > 1) {
            const audioIns = this.mediaManager.getAudioInstanceByRegion(this.elementModel?.key, MediaRegion.PLAYER);
            if (audioIns) {
                const slideIndex = this.elementModel.presentationRef.indexOfSlide(this.elementModel.slideRef);
                this.mediaManager.setPreserveAudioByKey(this.elementModel?.key, {
                    audioIns,
                    stopAtSlideIndex: this.animStopAtLength + slideIndex - 1,
                    startAtSlideIndex: slideIndex,
                });
            }
        }
        this.mediaManager.playAudioByRegion(this.elementModel?.key, MediaRegion.PLAYER);
    }

    // media togglePause播放, 若音视频播放则暂停，若音视频暂停则播放
    protected togglePauseHandler(): void {
        this.isPlaying() ? this.stopHandler() : this.playHandler();
    }

    // media停止播放
    protected stopHandler(): void {
        this.mediaManager.resetAudioByRegion(this.elementModel?.key, MediaRegion.PLAYER);
    }
}
